import axios from 'axios'

var myaxios = (url) => {
    return axios.create({
        headers: {
            "Authorization": `Bearer ${localStorage.getItem('api-token')}`
        },
        baseURL: url
    })
}

// myaxios.interceptors.response.use(function (response) {
//     if (response.data.posts && response.data.posts.error && response.data.posts.error != 0) {
//         eventHub.$emit('toast-error', response.data.posts.error)
//     }
//     return response;
// }, function (error) {
//     return Promise.reject(error);
// });

export default myaxios



// WEBPACK FOOTER //
// ./src/services/axios.service.js